export default "__VITE_ASSET__CeSyzS2k__"